export const DEFAULT_ACTION_PANEL_TRANSLATION_KEY = "table-actions-panel";
export const ACTION_PANEL_DROPDOWN_VALUE_ALL = "all";
